import React, { Component } from 'react';

import './modal.css';
import { buttonText } from '../../util/constants';

export class Modal extends Component {
  constructor(props) {
    super(props);
    this.messageRef = React.createRef();
    this.didFocusMessageRef = false;
  }

  componentDidUpdate() {
    if (this.props.message && !this.didFocusMessageRef) {
      this.messageRef.current.focus();
      this.didFocusMessageRef = true;
    }
  }

  render() {
    const { message, redirectButtonText, crossDomainData, onButtonClick, onRedirectClick } = this.props;
    return (
      <>
        {message ? (
          <div className="modal">
            <section className="modal-main">
              <h1 ref={this.messageRef} tabIndex={-1}>
                {message}
              </h1>
              {crossDomainData ? (
                <>
                  <button onClick={() => onButtonClick()}>{buttonText.stayOnCurrentPortal}</button>
                  <button className="redirect-button" onClick={() => onRedirectClick()}>
                    {redirectButtonText}
                  </button>
                </>
              ) : (
                <button onClick={() => onButtonClick()}>OK</button>
              )}
            </section>
          </div>
        ) : null}
      </>
    );
  }
}
